import {connect} from 'react-redux';
import UserLocator from '../components/UserLocator';
import {getShopsAtUserPosition} from '../actions';

const mapStateToProps = (state) => ({
  isLocating: state.user.isLocating
});

const mapDispatchToProps = dispatch => ({
  getShopsAtUserPosition: () => dispatch(getShopsAtUserPosition())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserLocator);
